/* ------------------------------------------------------------------
   «کاربر همین الان با پنل کار می‌کند؟» — مبنای «آنلاین» در چت
   ------------------------------------------------------------------
   🔴 چرا (بازبینی ‎2026-10-21).

   سرور هر درخواستِ واردشده را «حضور روی سایت» می‌شمرد
   (`EnsureSessionIsActive` ⟵ `PresenceRecorder`). ولی پنل خودش هم در
   پس‌زمینه درخواست می‌فرستد — شمارِ زنگوله هر ۶۰ ثانیه، کارتابل، و
   فهرست‌های رابطِ چت از راهِ RPC. پنجره‌ای که روی مانیتورِ دوم باز مانده
   بود صاحبش را تمامِ روز «آنلاین» نشان می‌داد، در حالی که تصمیمِ مالک
   «آنلاین یعنی در همین چند دقیقه با پنل کار کرده» است.

   پس هر درخواست سرآیندِ `X-Karbon-Presence: active|idle` دارد و سرور
   `idle` را ثبت نمی‌کند. «active» یعنی در `ACTIVE_MS` ِ گذشته کارِ واقعی
   شده: کلیک، کلید، چرخِ موشک، لمس، حرکتِ موشک، برگشتن به زبانه — یا
   همین کارها **داخلِ قابِ گفتگو**، که پنل خودش نمی‌بیند و قاب با
   `{carbonActivity}` خبر می‌دهد (`rpc/bridge.ts`).

   ⚠️ `ACTIVE_MS` کمتر از پنجرهٔ «آنلاین» ِ سرور (۵ دقیقه) و برابرِ
   فاصلهٔ پرسشِ زنگوله است: هر کارِ واقعی دستِ‌کم یک درخواستِ `active`
   پشتِ سرش دارد، پس «آخرین بازدید» حداکثر یک دقیقه از کارِ واقعی
   عقب است و حداکثر یک دقیقه هم از آن جلو.

   ⚠️ تمرکزی که در قابِ گفتگو مانده (کسی که در چت می‌نویسد و پنل هیچ
   رویدادی از آن نمی‌بیند) تا `FRAME_FOCUS_MS` هم «active» است — برای
   اسکریپتِ چتی که هنوز `{carbonActivity}` نمی‌فرستد. سقف دارد تا میزِ
   رهاشده با تمرکزِ مانده در چت هم تمامِ روز آنلاین نماند.

   ⚠️ هیچ دادهٔ رفتاری ذخیره نمی‌شود؛ فقط زمانِ آخرین کار در حافظهٔ صفحه.
   ------------------------------------------------------------------ */

export const PRESENCE_HEADER = 'X-Karbon-Presence'

/** کارِ واقعی در این فاصله ⟵ `active`. */
export const ACTIVE_MS = 60_000

/** تمرکزِ مانده در قابِ گفتگو حداکثر تا این مدت پس از آخرین کارِ دیده‌شده. */
export const FRAME_FOCUS_MS = 10 * 60_000

/* بارگذاریِ صفحه خودش کارِ کاربر است (باز کردن یا تازه کردن). */
let lastActivity = Date.now()

export function markUserActivity(): void {
  lastActivity = Date.now()
}

function focusInFrame(): boolean {
  try {
    return document.hasFocus() && document.activeElement instanceof HTMLIFrameElement
  } catch {
    return false
  }
}

export function presenceState(now: number = Date.now()): 'active' | 'idle' {
  const quiet = now - lastActivity
  if (quiet <= ACTIVE_MS) return 'active'
  if (quiet <= FRAME_FOCUS_MS && document.visibilityState === 'visible' && focusInFrame()) return 'active'
  return 'idle'
}

let installed = false

/** یک بار در آغازِ برنامه؛ شنونده‌ها passive‌اند و فقط یک عدد را عوض می‌کنند. */
export function installPresenceTracking(): void {
  if (installed || typeof window === 'undefined') return
  installed = true

  const options: AddEventListenerOptions = { passive: true, capture: true }
  for (const name of ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const) {
    window.addEventListener(name, markUserActivity, options)
  }

  /* ⚠️ حرکتِ موشک پشتِ سرِ هم می‌آید — یک بار در ثانیه بس است. */
  let lastMove = 0
  window.addEventListener(
    'pointermove',
    () => {
      const now = Date.now()
      if (now - lastMove < 1000) return
      lastMove = now
      markUserActivity()
    },
    options,
  )

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') markUserActivity()
  })
  window.addEventListener('focus', markUserActivity)

  /*
    🔴 کلیک روی قابِ گفتگو در پنل `pointerdown` نمی‌سازد (رویداد مالِ
    سندِ قاب است) — ولی تمرکز از پنجرهٔ پنل به قاب می‌رود و `blur` می‌آید.
  */
  window.addEventListener('blur', () => {
    window.setTimeout(() => {
      if (document.activeElement instanceof HTMLIFrameElement) markUserActivity()
    }, 0)
  })
}
